/**
 * 焦点图服务
 */

angular.module('editingCenterAppFocusModule').factory('appFocusService', [
    'appFocusApiService',
    '$modal',
    function(appFocusApiService, $modal) {
        return {

            /**
             * [appFocusTiming 客户端焦点图定时上下架]
             *
             * @param   {[type]}  itemArr  [item 需要上下架的稿件]
             * @param   {[type]}  type  [item 上架还是下架 1-上架，0-下架]
             * @param   {[type]}  success  [item 成功后的回调]
             *
             * @return  {[type]}        [return undefined]
             */
            appFocusTiming: function(itemArr, type, success) {
                var modalInstance = $modal.open({
                    templateUrl: './editingCenter/app/focus/service/timing/timing_tpl.html',
                    windowClass: 'time-app-focus',
                    backdrop: false,
                    controller: 'appFocusTimingCtrl',
                    resolve: {
                        options: function() {
                            return {
                                itemArr: itemArr,
                                type: type,
                            };
                        }
                    },
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            },
        };
    },
]);
